import { Link } from "react-router-dom";
import { Calendar, Tag, Smartphone, User } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export const MobileCtaBar = () => {
  const { settings } = useSite();
  const items = [
    { key: "book", label: "Book", icon: Calendar, to: "/booking", testid: "mobile-cta-bar-book" },
    { key: "packages", label: "Packages", icon: Tag, to: "/packages", testid: "mobile-cta-bar-packages" },
    { key: "app", label: "App", icon: Smartphone, to: "/contact", testid: "mobile-cta-bar-app" },
    { key: "login", label: "Login", icon: User, to: "/login", testid: "mobile-cta-bar-login" },
  ];
  return (
    <div
      data-testid="mobile-cta-bar"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/70 backdrop-blur-md lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-4">
        {items.map((it) => {
          const Icon = it.icon;
          const inner = (
            <div className="flex h-16 flex-col items-center justify-center gap-1">
              <Icon className="h-5 w-5 text-foreground" />
              <span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">{it.label}</span>
            </div>
          );
          return it.external ? (
            <a key={it.key} href={it.href} target="_blank" rel="noopener noreferrer" data-testid={it.testid}>{inner}</a>
          ) : (
            <Link key={it.key} to={it.to} data-testid={it.testid}>{inner}</Link>
          );
        })}
      </div>
    </div>
  );
};
